import { useIntl } from 'react-intl-next';

import { getProductTitle } from '../../../utils';

import { getViralSettingsFlags } from './getFlag';

import { useViralSettingsContext } from '../../ViralSettings';
import { useInvitePeopleContext } from '../../InvitePeople/InvitePeopleContext';
import { useProducts } from '../../ProductSelect';

export const useViralSettingsFlags = () => {
	const {
		viralSettingsDESEligibleStates: { checked: domains },
	} = useViralSettingsContext();
	const { cloudId } = useInvitePeopleContext();
	const { selectedProducts } = useProducts();
	const intl = useIntl();

	return (
		openInviteEnabled: boolean | undefined,
		directAccessAllDomainsEnabled: boolean | undefined,
	) =>
		getViralSettingsFlags(
			openInviteEnabled,
			directAccessAllDomainsEnabled,
			domains,
			cloudId || '',
			getProductTitle(selectedProducts[0]),
			intl,
		);
};
